// extracted by mini-css-extract-plugin
export default {"buttonSubmit":"ButtonSendForm_buttonSubmit__SUbqj"};